/* theme.js — mobile nav + product variant picker (progressive, no deps) */
(function () {
  "use strict";

  /* ---- Navigation: mobile menu, search overlay, mega scrim -------------- */
  function initNav() {
    var body = document.body;
    var header = document.querySelector("[data-header]");

    // Mobile menu
    var mnav = document.querySelector("[data-mobile-nav]");
    var openBtn = document.querySelector("[data-menu-open]");
    var closeBtn = document.querySelector("[data-menu-close]");
    function openMenu() {
      if (!mnav) return;
      mnav.classList.add("is-open"); mnav.setAttribute("aria-hidden", "false");
      body.classList.add("menu-open");
      if (openBtn) openBtn.setAttribute("aria-expanded", "true");
    }
    function closeMenu() {
      if (!mnav) return;
      mnav.classList.remove("is-open"); mnav.setAttribute("aria-hidden", "true");
      body.classList.remove("menu-open");
      if (openBtn) openBtn.setAttribute("aria-expanded", "false");
    }
    if (openBtn) openBtn.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);

    // Search overlay
    var srch = document.querySelector("[data-search]");
    var searchInput = document.querySelector("[data-search-input]");
    function openSearch(e) {
      if (!srch) return;
      if (e) e.preventDefault();
      srch.classList.add("is-open"); srch.setAttribute("aria-hidden", "false");
      body.classList.add("search-open");
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 120);
    }
    function closeSearch() {
      if (!srch) return;
      srch.classList.remove("is-open"); srch.setAttribute("aria-hidden", "true");
      body.classList.remove("search-open");
    }
    document.querySelectorAll("[data-search-open]").forEach(function (el) {
      el.addEventListener("click", openSearch);
    });
    var searchClose = document.querySelector("[data-search-close]");
    if (searchClose) searchClose.addEventListener("click", closeSearch);

    // Escape closes everything
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeMenu(); closeSearch(); }
    });

    // Desktop mega-menu scrim
    if (header) {
      header.querySelectorAll(".has-mega").forEach(function (item) {
        item.addEventListener("mouseenter", function () { header.classList.add("is-mega"); });
        item.addEventListener("mouseleave", function () { header.classList.remove("is-mega"); });
        item.addEventListener("focusout", function () {
          if (!item.contains(document.activeElement)) header.classList.remove("is-mega");
        });
      });
    }
  }

  /* ---- Product variants ------------------------------------------------- */
  function initProduct() {
    var root = document.querySelector("[data-product]");
    if (!root) return;

    var dataEl = root.querySelector("[data-variants-json]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var priceMap = {};
    var mapEl = root.querySelector("[data-price-map]");
    if (mapEl) { try { priceMap = JSON.parse(mapEl.textContent); } catch (e) {} }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector("[data-price]");
    var addBtn = root.querySelector("[data-add]");
    var selects = Array.prototype.slice.call(root.querySelectorAll("[data-option]"));

    // No option selectors => single/default-variant product. The server already
    // rendered the correct button state, so don't touch it.
    if (!selects.length) return;

    function currentVariant() {
      var chosen = selects.map(function (s) { return s.value; });
      return variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function update() {
      var v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl && priceMap[v.id]) priceEl.textContent = priceMap[v.id];
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      }
    }

    selects.forEach(function (s) { s.addEventListener("change", update); });
    update();
  }

  function init() { initNav(); initProduct(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
